import React from 'react';
import { QuoteIcon, StarIcon } from 'lucide-react';
const TestimonialSection = () => {
  return <section className="py-20 px-6 md:px-12 bg-teal-50" data-id="element-268">
      <div className="max-w-4xl mx-auto" data-id="element-269">
        <div className="bg-white p-8 md:p-12 rounded-xl shadow-md relative" data-id="element-270">
          {/* Trustpilot-style header */}
          <div className="absolute -top-5 left-1/2 transform -translate-x-1/2 bg-white px-6 py-2 rounded-lg shadow-md flex items-center" data-id="element-271">
            <div className="flex mr-2" data-id="element-272">
              {[...Array(5)].map((_, i) => <StarIcon key={i} className="h-5 w-5 text-green-500 fill-current" data-id="element-273" />)}
            </div>
            <span className="text-sm font-medium text-gray-600" data-id="element-274">
              Verified Review
            </span>
          </div>
          <div className="pt-4" data-id="element-275">
            <QuoteIcon className="h-8 w-8 text-teal-700 mb-4" data-id="element-276" />
            <blockquote className="text-xl md:text-2xl text-gray-700 italic mb-8" data-id="element-277">
              "This is the kind of support I've been wishing I could give my
              clients for years. It complements the work we do in session
              perfectly—and the best part is, I didn't have to create any of
              it."
            </blockquote>
            <div className="flex items-center" data-id="element-278">
              <div className="w-12 h-12 bg-teal-200 rounded-full flex items-center justify-center" data-id="element-279">
                <span className="text-teal-800 font-bold" data-id="element-280">JM</span>
              </div>
              <div className="ml-4" data-id="element-281">
                <p className="font-medium text-teal-900" data-id="element-282">
                  Jennifer Martinez, LMFT
                </p>
                <p className="text-gray-600" data-id="element-283">
                  Somatic Therapist, Founder Member
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="mt-16" data-id="element-284">
          <h3 className="text-2xl md:text-3xl font-bold text-teal-900 text-center mb-8" data-id="element-285">
            Why This Is Different From Anything You've Tried
          </h3>
          <div className="grid md:grid-cols-2 gap-8" data-id="element-286">
            <div className="bg-white p-6 rounded-lg shadow-sm" data-id="element-287">
              <h4 className="text-xl font-semibold text-teal-800 mb-4" data-id="element-288">
                Most resources:
              </h4>
              <ul className="space-y-3" data-id="element-289">
                <li className="flex items-start" data-id="element-290">
                  <span className="text-red-500 mr-2" data-id="element-291">✗</span>
                  <span data-id="element-292">Focus on mindset, not the body</span>
                </li>
                <li className="flex items-start" data-id="element-293">
                  <span className="text-red-500 mr-2" data-id="element-294">✗</span>
                  <span data-id="element-295">
                    Require you to be the tech support, coach, and guide
                  </span>
                </li>
                <li className="flex items-start" data-id="element-296">
                  <span className="text-red-500 mr-2" data-id="element-297">✗</span>
                  <span data-id="element-298">Cost $100–$300 per client license</span>
                </li>
              </ul>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-sm" data-id="element-299">
              <h4 className="text-xl font-semibold text-teal-800 mb-4" data-id="element-300">
                Neurotoned is built different:
              </h4>
              <ul className="space-y-3" data-id="element-301">
                <li className="flex items-start" data-id="element-302">
                  <span className="text-teal-700 font-bold mr-2" data-id="element-303">✓</span>
                  <span data-id="element-304">
                    Based on polyvagal theory, somatic therapy, and trauma
                    neuroscience
                  </span>
                </li>
                <li className="flex items-start" data-id="element-305">
                  <span className="text-teal-700 font-bold mr-2" data-id="element-306">✓</span>
                  <span data-id="element-307">
                    Built to scale support without diluting your impact
                  </span>
                </li>
                <li className="flex items-start" data-id="element-308">
                  <span className="text-teal-700 font-bold mr-2" data-id="element-309">✓</span>
                  <span data-id="element-310">Designed for daily integration, not just insight</span>
                </li>
              </ul>
            </div>
          </div>
          <p className="text-center text-xl font-medium text-teal-900 mt-8" data-id="element-311">
            It's the toolkit you've been missing. And now, it's yours to
            offer—at scale.
          </p>
        </div>
      </div>
    </section>;
};
export default TestimonialSection;